export type OnboardingStep = `OnboardingStep${1 | 2 | 3}`;
export function isOnboardingStep(key: string): key is OnboardingStep {
	return /^OnboardingStep[1-3]$/.test(key);
}
